import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, IconButton } from "@material-ui/core";
import Title from "components/Admin/Title/Title";
import { useStyles } from "features/admin/styles";
import SubTitle from "components/Admin/Title/SubTitle";
import { MdRefresh, MdSave, MdChevronLeft } from "react-icons/md";
import { useForm } from "react-hook-form";
import {
  Form,
  ProgressBar,
  SubmitButton,
  TitleContainer,
  Zone,
  BorderLinearProgress,
} from "components/Admin/InputFields/utils";
import { useNavigate } from "react-router-dom";
import Preloader from "components/Preloader/Preloader";
import styled from "styled-components";
import ImageField, { Content } from "components/Admin/InputFields/ImageField";
import TextInputField from "components/Admin/InputFields/TextInputField";
import { selectResponse } from "features/admin/adminSlice";
import CheckboxField from "components/Admin/InputFields/CheckboxField";
interface BannerFormProps {
  formTitle: string;
  onSubmit: (data: any) => void;
  fields: any;
  progress: number;
}

const BannerForm: React.FC<BannerFormProps> = ({
  formTitle,
  onSubmit,
  fields,
  progress,
}) => {
  const [resetForm, setResetForm] = useState(false);
  const classes = useStyles();
  const { handleSubmit, setValue, control } = useForm();
  const formRef = useRef<HTMLFormElement>(null);
  const isEditPage = window.location.pathname.includes("edit");
  const response = useSelector(selectResponse);
  const navigate = useNavigate();

  const createEmptyImage = (id: number): Content => {
    return {
      id: id,
      name: fields.data[0].name,
      file_name: undefined,
      contentType: undefined,
      image: undefined,
      is_main_image: false,
    };
  };
  const [image, setImage] = useState<Content>(createEmptyImage(0));

  useEffect(() => {
    setImage(createImageState(0, fields.data[0].value));
  }, []);

  useEffect(() => {
    if (response && response.hasError) {
      reset();
    }
  }, [response]);

  const createImageState = (id: number, res?: Content): Content => {
    return res
      ? {
          id: id,
          name: fields.data[0].name, //TODO
          file_name: res.file_name,
          contentType: res.contentType,
          image: res.image,
          is_main_image: false,
        }
      : createEmptyImage(id);
  };
  const reset = () => {
    setResetForm(!resetForm);
  };
  const renderFields = (data: any) => {
    return (
      <>
        <ImageField
          content={image}
          control={control}
          reset={resetForm}
          required={false}
          setValue={setValue}
          ratio={"calc(480 / 1280 * 100%)"}
          maxSizeBytes={3000000}
        />
        <TextInputField
          item={data[1]}
          control={control}
          reset={resetForm}
          setValue={setValue}
        />
        <TextInputField
          item={data[2]}
          control={control}
          reset={resetForm}
          setValue={setValue}
        />
        <CheckboxField
          item={data[3]}
          control={control}
          reset={resetForm}
          setValue={setValue}
        />
      </>
    );
  };

  return (
    <>
      <TitleContainer>
        <IconButton aria-label="Назад" onClick={() => navigate(-1)}>
          <MdChevronLeft />
        </IconButton>
        {!isEditPage && (
          <IconButton aria-label="Обнови" onClick={reset}>
            <MdRefresh />
          </IconButton>
        )}

        <Title>{formTitle}</Title>
      </TitleContainer>

      <Form
        ref={formRef}
        onSubmit={handleSubmit(onSubmit)}
        encType="multipart/form-data"
      >
        <Grid container spacing={1}>
          {fields ? (
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={12}>
                <Zone className={classes.paper}>
                  <SubTitle>Размер за банера 1920x442</SubTitle>
                  {renderFields(fields.data)}
                </Zone>
              </Grid>
            </Grid>
          ) : (
            <LoaderContainer>
              <Preloader />
            </LoaderContainer>
          )}
        </Grid>
        <ProgressBar>
          <BorderLinearProgress variant="determinate" value={progress} />
        </ProgressBar>
        <SubmitButton
          disabled={progress !== 0 && progress !== 100}
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<MdSave size="1.5rem" />}
        >
          Запази
        </SubmitButton>
      </Form>
    </>
  );
};
const LoaderContainer = styled.div`
  width: 100%;
  margin: 30px 0;
`;

export default BannerForm;
